import { Node } from 'reactflow';

import { Slide } from '../../../../../SlideComponents/slide.types';
import { NODE_WIDTH, NODES_HORIZONTAL_GAP } from './generateAllNodes';

type GenerateSlideNodesProps = {
  slides: Slide[];
  largestRowWidth: number;
};

const generateSlideNodes = ({ slides, largestRowWidth }: GenerateSlideNodesProps) => {
  const rowWidth =
    slides.length * NODE_WIDTH + (slides.length - 1) * NODES_HORIZONTAL_GAP;
  let currentX = (largestRowWidth - rowWidth) / 2;
  const currentY = 800;

  const nodes: Node[] = [];
  for (const [index, eachSlide] of slides.entries()) {
    nodes.push({
      id: eachSlide.id,
      data: {
        label: `Slide ${index + 1} `,
      },
      type: 'output',
      style: {
        backgroundColor: '#73ff2d66',
        fontWeight: 'bold',
      },

      position: { x: currentX, y: currentY },
    });
    currentX += NODE_WIDTH + NODES_HORIZONTAL_GAP;
  }

  return nodes;
};

export default generateSlideNodes;
